import { useCallback, useState } from "react";
import { HelpCentreSection } from "../help-center-types";

export interface UseHelpCenterSection {
  section: HelpCentreSection | null;
  selectSection: (section: HelpCentreSection) => void;
  resetSection: () => void;
}

export const useHelpCenterSection = (): UseHelpCenterSection => {
  const [section, setSection] = useState<HelpCentreSection | null>(null);

  const selectSection = useCallback(
    (nextSection: HelpCentreSection) => setSection(nextSection),
    []
  );

  const resetSection = useCallback(() => setSection(null), []);

  return { section, selectSection, resetSection };
};
